import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a00b276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "mt-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Kathmandu")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Bhaktapur")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Lalitpur")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Click to upload ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Loading")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.paramId ? "Edit Patient" : "Add a New Patient"), 1),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_a_form, _mergeProps({
        model: _ctx.formState,
        name: "validate_other"
      }, _ctx.formItemLayout, { onFinish: _ctx.onFinish }), {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "First Name",
            name: "firstName",
            rules: [
          !_ctx.paramId && {
            required: true,
            message: 'Please input your first name!',
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.firstName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.firstName) = $event)),
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.firstName
              }, null, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "Last Name",
            name: "lastName",
            rules: [
          !_ctx.paramId && {
            required: true,
            message: 'Please input your last name!',
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.lastName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.lastName) = $event)),
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.lastName
              }, null, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "Email",
            name: "email",
            rules: [!_ctx.paramId && { required: true, message: 'Please input your email!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.email,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.email) = $event)),
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.email
              }, null, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "Contact",
            name: "contact",
            rules: [!_ctx.paramId && { required: true, message: 'Please input your contact!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                style: {"width":"100%"},
                value: _ctx.formState.contact,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.contact) = $event)),
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.contact
              }, null, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "Date of Birth",
            name: "dob",
            rules: [!_ctx.paramId && { required: true, message: 'Please input your dob!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                size: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    "value-format": "YYYY-MM-DD",
                    value: _ctx.formState.dob,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.dob) = $event)),
                    defaultValue: _ctx.currentPatient && _ctx.currentPatient.dob
                  }, null, 8, ["value", "defaultValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            name: "address",
            label: "Address",
            "has-feedback": "",
            rules: [
          !_ctx.paramId && {
            required: true,
            message: 'Please select your district!',
          },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.address,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.address) = $event)),
                placeholder: "Please select a district",
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.address
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Kathmandu" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "Bhaktapur" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "Lalitpur" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            name: "allergies",
            label: "Allergies"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState['allergies'],
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState['allergies']) = $event)),
                mode: "multiple",
                placeholder: "Please select allergies",
                defaultValue: _ctx.currentPatient && _ctx.currentPatient.allergies
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergiesList, (allergy) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: allergy,
                      value: allergy
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(allergy), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "defaultValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "image",
            label: "Image"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_upload, {
                action: _ctx.imageUrl,
                headers: _ctx.headers,
                fileList: _ctx.formState.image,
                "onUpdate:fileList": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.image) = $event)),
                onChange: _ctx.handleChange,
                name: "image",
                "list-type": "picture"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    icon: _withCtx(() => [
                      _createVNode(_component_UploadOutlined)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["action", "headers", "fileList", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { "wrapper-col": { span: 12, offset: 6 } }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    loading: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    "html-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["model", "onFinish"])
    ])
  ], 64))
}